import { render } from "./AddDemandePage.vue?vue&type=template&id=5a3666f0&ts=true"
import script from "./AddDemandePage.vue?vue&type=script&lang=ts"
export * from "./AddDemandePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__